<template>
  <div id="deviceready">
    <!--    <qrcode-stream :camera="camera" :track="paintCenterText" ></qrcode-stream>-->
    <div class="content_response" v-if="responses">
      <transition-group enter-active-class="animated bounceIn" name="list">
        <div v-for="(response,index) in responses" :key="index+1" class="form_response" :class="response.type">
          <p>{{ response.msg }}</p>
        </div>
      </transition-group>
    </div>

    <div id="cameraAndPicture" v-if="currentMedia === ''">
      <div class="actions">
        <font-awesome-icon color="#00d6ff" id="switch" size="md" class="swicth" @click="onSwitch" icon="exchange-alt"
                           v-if="deviceCheck(['mobile','tablet'])"/>
        <font-awesome-icon color="#00d6ff" id="addmask" size="xs" class="addmask" :class="{'active':activePopup}"
                           @click="addMask" icon="plus"/>

        <!--        <div class="action torch" id="torch">Torch</div>-->
        <!--        <font-awesome-icon color="#00d6ff" id="scan" size="lg" v-if="mode==='camera'" @click="hideFilter" class="" icon="qrcode"/>-->
      </div>
    </div>
    <CameraControls v-if="streamingCanvas && currentMedia === ''" :streamingCanvas="streamingCanvas"
                    :saveMedia="saveMedia"/>
    <SavePicture v-if="currentMedia !== ''" :url="currentMedia" :removeMedia="removeMedia"/>
    <!--    <ScanCard v-if="scancard" :scancard="scancard" @active-mask="setScancard" />-->
    <PopUp v-if="activePopup" :type="type" :body="body" @response="updateResponse" @close-popup="updatePopup"/>
  </div>

</template>

<script>
import CameraControls from "./Controls/CameraControls";
import {store} from '../../store/store';

import SavePicture from "./Widgets/SavePicture";
import PopUp from "../Modals/Modal";
import {mapState, mapActions} from "vuex";


export default {
  name: 'CameraView',
  components: {
    CameraControls,
    SavePicture,
    PopUp
  },
  data() {
    return {
      store,
      streamingCanvas: null,
      media: '',
      camera: "auto",
      qrcode_uid: this.$route.params.qrcode_uid,
      currentRoute: this.$route.name,
      activePopup: false,
      body: null,
      type: 'addmask',
      responses: null,
      device: true
    }
  },
  computed: {
    ...mapState([
      "user",
      "masks",
      "logged",
      "currentMedia"
    ])
  },
  created() {
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "LandingPage"});

    const MaskCanvas = document.querySelector('#jeeFaceFilterCanvas');

    // document.querySelector('.qrcode-stream-wrapper').style.transform ="translate(0, 0) rotateY(180deg)";

    if (MaskCanvas) {
      MaskCanvas.style.display = "block";
      this.streamingCanvas = MaskCanvas;
    } else {
      const canvas = document.createElement('canvas');
      canvas.id = 'jeeFaceFilterCanvas';
      canvas.className = 'jeeFaceFilterCanvas';
      canvas.ref = "mainCanvas";
      canvas.width = document.body.clientWidth;
      canvas.height = document.body.clientHeight;
      canvas.style.transform = "translate(0, 0) rotateY(180deg)";
      canvas.style.position = "absolute";
      canvas.style.zIndex = "-1";
      canvas.style.opacity = "1";

      document.querySelector('#deviceready').appendChild(canvas);
      this.streamingCanvas = canvas;
    }
    // openCamera()

    main()
    resetCamera()

  },
  destroyed() {
    closeCamera()

    // document.querySelector('#jeeFaceFilterCanvas').style.display = "none";
    // this.removeMedia();
  },
  methods: {
    ...mapActions(['getUser']),
    deviceCheck(arrayValue) {
      let device = getDevice()
      return arrayValue.includes(device)
    },
    updateResponse(data) {
      this.responses = data
      if (data.data.type === 'succeed') {
        this.activePopup = null
        setTimeout(this.updateResponses, 1000)
      }
    },
    updatePopup() {
      this.activePopup = false
    }, updateResponses() {
      this.responses = false
    },
    saveMedia(media) {
      store.state.currentMedia = media
    },
    onSwitch() {
      onSwitch()
    },
    removeMedia() {
      this.media = '';
      const preview = document.getElementById("mediaPreview");
      preview.removeChild(preview);
    },
    addMask(e) {
      this.type = 'addmask'
      this.activePopup = !this.activePopup
    }

  },
  watch: {
    responses: function (responses) {
      this.responses = responses
    }
  }
}
</script>

<style scoped>

#mediaPreview {
  width: 100vw;
}

body {
  background: #000;
}

#deviceready {
  height: 100%;
}

#openMouthInstruction {
  display: none;
}


.image > img {
  width: 100%;
}

.gallery > * {
  margin: 4px;
}


@media screen and (min-aspect-ratio: 1/1) and (min-width: 400px) {
  .app {

  }
}

/* Canvas */
canvas.raster {
  top: 0;
  left: 0;
  position: absolute;
}

/* Actions */
.actions {
  padding: 4px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  right: 15px;
  top: 5px;
  position: fixed;
}

.actions svg {
  width: 1.8em;
  height: 1.8em;
}

.actions > * {
  margin: 10px 0px;
}

div.action {
  width: 50px;
  height: 50px;
  line-height: 50px;
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  position: relative;
}

.addmask {
  border-radius: 50%;
  border: 1px solid #00d6ff;
  padding: 5px;
  transition: .3s;
}

.addmask:hover, .addmask.active {
  transform: rotate(360deg);
  background: #00d6ff;
  color: #fff;
  cursor: pointer;
}

.switch, .switch:active {
  transition: .3s;
  color: #00d6ff;
}

.swicth:hover {
  transform: rotate(180deg);
}

@media screen and (max-width: 750px) {
  .actions {
    top: env(safe-area-inset-top);
    right: 10px;
  }

  .jeeFaceFilterCanvas {
    height: 100vh;
  }


}

</style>
